import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Settings, ShieldAlert, Lightbulb } from 'lucide-react';
export function ProblemSlide() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      y: 20,
      opacity: 0
    },
    show: {
      y: 0,
      opacity: 1
    }
  };
  return <div className="h-full w-full flex flex-col items-center justify-center px-8 md:px-16 bg-slate-950" data-id="element-108">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-109">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-110">
          CPO Challenges at Scale
        </h2>
        <p className="text-lg text-slate-400" data-id="element-111">
          Growing pains often hit three critical areas
        </p>
      </motion.div>

      <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-6xl" data-id="element-112">
        {/* Operations */}
        <motion.div variants={item} className="bg-slate-900/50 border border-slate-800 p-8 rounded-2xl hover:border-blue-500/30 transition-colors" data-id="element-113">
          <div className="w-14 h-14 bg-blue-900/30 rounded-xl flex items-center justify-center mb-6" data-id="element-114">
            <Settings className="w-8 h-8 text-blue-400" data-id="element-115" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-116">Operations</h3>
          <p className="text-slate-400 leading-relaxed" data-id="element-117">
            Struggling with efficient rollout, installation, and maintenance at
            scale. Support becomes a bottleneck as driver numbers grow.
          </p>
        </motion.div>

        {/* Risk */}
        <motion.div variants={item} className="bg-slate-900/50 border border-slate-800 p-8 rounded-2xl hover:border-red-500/30 transition-colors" data-id="element-118">
          <div className="w-14 h-14 bg-red-900/20 rounded-xl flex items-center justify-center mb-6" data-id="element-119">
            <ShieldAlert className="w-8 h-8 text-red-400" data-id="element-120" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-121">Risk</h3>
          <p className="text-slate-400 leading-relaxed" data-id="element-122">
            Customer lock-in with hardware/software providers. Losing control of
            branding and flexibility for future technology shifts.
          </p>
        </motion.div>

        {/* Propositions */}
        <motion.div variants={item} className="bg-slate-900/50 border border-slate-800 p-8 rounded-2xl hover:border-green-500/30 transition-colors" data-id="element-123">
          <div className="w-14 h-14 bg-green-900/20 rounded-xl flex items-center justify-center mb-6" data-id="element-124">
            <Lightbulb className="w-8 h-8 text-green-400" data-id="element-125" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-126">
            New Propositions
          </h3>
          <p className="text-slate-400 leading-relaxed" data-id="element-127">
            Difficulty bringing compelling, differentiating approaches to
            market. Slow to launch new revenue models and services.
          </p>
        </motion.div>
      </motion.div>
    </div>;
}